import { connect } from "react-redux";
import { UserRole } from "../../constants/RoleEnum";
import AdminMenu from "../menu/adminMenu";
import CollegeAdminMenu from "../menu/collegeAdminMenu";
import DepartmentAdminMenu from "../menu/departmentAdminMenu";
import FacultyMenu from "../menu/facultyMenu";
import StaffMenu from "../menu/staffMenu";
import StudentMenu from "../menu/studentMenu";
import { baseURL } from "../../constants/commonConstants";
import { ROUTER_URL } from "../../constants/routerUrl";

const Profile = ({ user, currentRole }: any) => {
  const renderMenu = () => {
    switch (currentRole) {
      case UserRole.SuperAdmin:
        return <AdminMenu />;
      case UserRole.CollegeAdmin:
        return <CollegeAdminMenu />;
      case UserRole.DepartmentAdmin:
        return <DepartmentAdminMenu />;
      case UserRole.Staff:
        return <StaffMenu />;
      case UserRole.Faculty:
        return <FacultyMenu />;
      case UserRole.Student:
        return <StudentMenu />;
      default:
        return null;
    }
  };

  const getDashboardPath = () => {
  switch (currentRole) {
    case UserRole.SuperAdmin:
      return ROUTER_URL.COLLEGE_INDEX;
    case UserRole.CollegeAdmin:
      return ROUTER_URL.COLLEGE_DETAILS;
    case UserRole.DepartmentAdmin:
      return ROUTER_URL.DEPARTMENT_DETAILS;
    case UserRole.Faculty:
      return ROUTER_URL.FACULTY_DASHBOARD;
    case UserRole.Staff:
      return ROUTER_URL.STAFF_DASHBOARD;
    case UserRole.Student:
      return ROUTER_URL.STUDENT_DASHBOAD;
    default:
      return "/";
  }
};

  return (
    <>
      <nav>
        <div className="logo">
          <a href={getDashboardPath()}>
            <img src="/assets/images/andrew-logo.png" alt="Andrews College" />
          </a>
        </div>
        <div className="profile">
          <div
            className="profile-img"
          //style={{ backgroundImage: `url(/assets/images/profile05.jpg)` }}
          >
            <img
              src={baseURL + user?.image}
              alt="Profile"
              onError={(e) => {
                e.currentTarget.src = "/assets/images/icon/DefaultImage.jpeg";
              }}
            />
          </div>
          <h6>{user?.displayName}</h6>
          <p>{user?.email}</p>
          {/* <p>{user?.email === "demo-staff@analystortech.com"
            ? "robert1@andrews.edu"
            : user?.email === "demo-faculty@analystortech.com"
              ? "drobney2@andrews.edu"
              : user?.email}</p> */}
        </div>
        
        {renderMenu()}
      </nav>
      <div className="dackdrop-nav"></div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  currentRole: state.userDetails.userProfileData?.currentRole,
  user: state.userDetails.userProfileData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
